export default "__VITE_ASSET__0TTVrhQ6__"